import Vue from 'vue'
import Router from 'vue-router'
import Start from './views/Start.vue'

Vue.use(Router)
console.log("HERE: ", process.env.NODE_ENV, process.env.BASE_URL)
export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ?
  '/arrival/' : '/',
  // base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'start',
      component: Start
    },
    {
      path: '/shop',
      name: 'shop',
      component: () =>
        import ( /* webpackChunkName: "shop" */ './views/Shop.vue')
    },
    {
      path: '/meditation',
      name: 'meditation',
      component: () =>
        import ( /* webpackChunkName: "meditation" */ './views/Meditation.vue')
    },
    {
      path: '/credits',
      name: 'credits',
      component: () =>
        import ( /* webpackChunkName: "credits" */ './views/Credits.vue')
    },
    {
      path: '/journey',
      name: 'journey',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import ( /* webpackChunkName: "journey" */ './views/Journey.vue')
    }
  ]
})